<template>
    <a-card :title="$t('screenTitle.chargeViaCryptCoin')">
        <a-skeleton :loading="isLoading" active>
            <div v-if="transPrefix">
                <!-- <div v-if="transId"> -->
                    <a-alert message="Mã Giao Dịch lần này" type="info" class="mb-20" v-if="false">
                        <template #description>
                            <a-tag color="purple">
                                <template #icon>
                                    <SyncOutlined style="font-size: 20px; vertical-align: baseline;" spin />
                                </template>
                                <a-typography-title :level="2" style="margin:0;display: inline-block;" copyable>X{{ transPrefix }}X{{ transId }}X</a-typography-title>
                            </a-tag>
                        </template>
                    </a-alert>
                    <a-collapse v-model:activeKey="bankAccsActiveKeys">
                        <a-collapse-panel key="list" header="Thông tin chuyển khoản">
                            <a-table :dataSource="bankAccs" :columns="bankAccsCols" :pagination="false" :loading="isFetchingBankAccs" class="mb-20">
                                <template #bodyCell="{ column, text }">
                                    <template v-if="column.dataIndex === 'address'">
                                        <a-typography-title :level="3" copyable>{{ text }}</a-typography-title>
                                    </template>
                                </template>
                            </a-table>

                            <a-button type="primary" size="large" block @click="fetchBackAccs()" :loading="isFetchingBankAccs">Nhận thông tin Ví Tiền mã hoá để chuyển khoản</a-button>
                        </a-collapse-panel>
                        <a-collapse-panel key="help" header="Hướng dẫn nạp">
                            <!-- <div>Chỉ cần nhập [Mã Giao Dịch] lần này vào ô [Nội dung chuyển khoản] kèm số tiền muốn nạp và chờ đợi giây lát, tiền sẽ tự động được cộng.</div> -->
                        </a-collapse-panel>
                        <a-collapse-panel key="info" header="Giới thiệu & Lưu ý">
                            <a-typography-paragraph>
                                <a-typography-title :level="2">Giới thiệu nạp thông qua Tiền mã hoá / Cryptocurrencies</a-typography-title>
                                <ul>
                                    <li>Là hình thức sử dụng chuyển các loại tiền mã hoá, giao dịch tự động cập nhật từ phía mạng chuyển khoản và cộng tiền trực tiếp vào tài khoản của bạn với chi phí CỰC RẺ</li>
                                    <li>Bạn chỉ cần có một tài khoản của các sàn Tiền điện tử (VD: Binance.com, Remitano.com) và sở hữu một trong số các đồng tiền trên "Thông tin chuyển khoản" là có thể sử dụng dịch vụ</li>
                                    <li>Tài khoản sẽ được tự động cộng tiền ngay sau khi ví tiền mã hoá của chúng tôi nhận được thông tin thanh toán thành công</li>
                                </ul>
                                <a-typography-title :level="2">Quý khách hàng lưu ý</a-typography-title>
                                <ul>
                                    <!-- <li>Chỉ cần nhập đúng mã giao dịch vào phần "Ghi chú" hay "Tin nhắn",... tại màn hình chuyển của dịch vụ bạn sử dụng, hệ thống của chúng tôi sẽ tự động xử lí giao dịch sau vài giây khi nhận được thông tin thanh toán thành công</li> -->
                                    <li>Số tiền nhận được sẽ được quy đổi theo giá bán ra của loại tiền đó tại thời điểm check tương ứng trên sàn Binance.com</li>
                                    <li>Mọi chi tiết xin liên hệ fanpage để được hỗ trợ</li>
                                </ul>
                            </a-typography-paragraph>
                        </a-collapse-panel>
                    </a-collapse>
                <!-- </div>
                <div v-else>
                    <a-button type="primary" size="large" block @click="genNewPayment()" :loading="isGenerating">Nhận Mã Giao Dịch mới</a-button>
                </div> -->
            </div>
            <a-alert v-else message="Xảy ra lỗi, vui lòng thử lại" type="warning">
                <template #description>
                    <a-button type="primary" @click="fetchPaymentInfo()">Thử lại</a-button>
                </template>
            </a-alert>
        </a-skeleton>

        <div v-if="false && hasManagerPermission" class="mt-20">
            <a-table :dataSource="dataSource" :columns="columns" :pagination="pagination" :loading="isLoadingTable" :scroll="{x: '100%'}">
                <template #bodyCell="{ column, record }">
                    <template v-if="column.key === 'action'">
                        <a-space>
                            <a-tooltip v-if="record.status === PaymentStatus.NOT_PAID" title="Huỷ giao dịch">
                                <a-button type="primary" danger size="small" @click="deletePaymentConfirm(record)">
                                    <template #icon>
                                        <DeleteOutlined />
                                    </template>
                                </a-button>
                            </a-tooltip>
                        </a-space>
                    </template>
                </template>
            </a-table>
        </div>
    </a-card>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, onUnmounted, ref, watch, } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";

import { Alert, Button, Card, Collapse, message, Modal, Skeleton, Space, Table, Tag, Tooltip, Typography, } from "ant-design-vue";
import { ColumnType, TablePaginationConfig } from "ant-design-vue/lib/table";
import { SyncOutlined, DeleteOutlined, } from "@ant-design/icons-vue";

import { RouteName } from "@/router";
import ApiRequest from "@/utils/ApiRequest";
import { UserRole } from "@/store/modules/user";
import { number_format } from "@/utils/helpers";
import { UserInfo } from '@/store/modules/user';
import { paymentStatusText, PaymentStatus } from "./HistoryView.vue";

export default defineComponent({
    components: {
        ACard: Card,
        AAlert: Alert,
        AButton: Button,
        ATooltip: Tooltip,
        ATable: Table,
        ATag: Tag,
        ATypographyTitle: Typography.Title,
        ATypographyParagraph: Typography.Paragraph,
        ASpace: Space,
        ASkeleton: Skeleton,
        ACollapse: Collapse,
        ACollapsePanel: Collapse.Panel,
        // AImage: Image,

        SyncOutlined,
        DeleteOutlined,
    },

    setup() {
        const { t } = useI18n();
        const store = useStore();

        const bankAccsActiveKeys = ref<string[]>(['list']);

        const isLoadingTable = ref(true);
        const dataSource = ref([]);
        const columns = ref<ColumnType[]>([
            {
                title: 'ID',
                dataIndex: 'id',
            },
            {
                title: t('labelText.payment_username'),
                dataIndex: ['user', 'name'],
            },
            {
                title: t('labelText.payment_status'),
                dataIndex: 'status',
                customRender: ({ text }) => paymentStatusText(text),
            },
            {
                title: t('labelText.payment_coin'),
                dataIndex: 'amount',
                customRender: ({ text }) => {
                    return number_format(text);
                },
            },
            {
                title: t('labelText.payment_transaction_info'),
                dataIndex: 'transaction_info',
            },
            {
                title: t('labelText.created_at'),
                dataIndex: "created_at",
            },
            {
                title: t('labelText.updated_at'),
                dataIndex: "updated_at",
            },
            {
                title: t('text.action'),
                key: "action",
            },
        ]);
        const pagination = ref<TablePaginationConfig>({
            current: 1,
        });

        const fetchData = () => {
            isLoadingTable.value = true;

            ApiRequest.get('/payments/ebanks', {
                page: pagination.value.current,
            })
                .then(res => {
                    const resData = res.data;

                    dataSource.value = resData.data;

                    ApiRequest.setPaginate(pagination.value, resData);
                })
                .finally(() => {
                    isLoadingTable.value = false;
                })
        };
        pagination.value.onChange = (page: number) => {
            pagination.value.current = page;

            fetchData();
        };

        const isLoading = ref(true);
        const userInfo = computed<UserInfo>(() => store.getters.user);
        const hasManagerPermission = computed<boolean>(() => store.getters.hasManagerPermission);

        const transPrefix = ref<string>();
        const transId = ref<number>();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const bankAccs = ref<any[]>();
        const bankAccsCols = ref<ColumnType[]>([
            {
                title: 'Tên đồng tiền',
                dataIndex: 'name',
            },
            {
                title: 'Địa chỉ ví (Wallet Address)',
                dataIndex: 'address',
            },
            {
                title: 'Mạng sử dụng (Network)',
                dataIndex: 'network',
            },
            // {
            //     title: 'Mã QR',
            //     dataIndex: 'qr',
            // },
        ]);

        let curPaymentTimeout: number;
        const genCurPaymentTO = () => curPaymentTimeout = setTimeout(() => {
            if (!transId.value) {
                return;
            }

            ApiRequest.get(`/payments/ebanks/${transId.value}`)
                .then(async res => {
                    const resData = res.data.data;
                    if (resData.status !== PaymentStatus.NOT_PAID) {
                        transId.value = undefined;

                        if (resData.status === PaymentStatus.COMPLETED) {
                            Modal.success({
                                title: t('message.success'),
                                content: `Tài khoản đã được cộng ${number_format(resData.amount)} ${t('labelText.payment_coin')}`,
                            });
                        } else {
                            Modal.error({
                                title: 'Giao dịch thất bại',
                                content: `Trạng thái: ${paymentStatusText(resData.status)}`,
                            });
                        }
                    }
                })
                .finally(() => {
                    genCurPaymentTO();
                });
        }, 5000);

        watch(() => transId.value, (val) => {
            if (val) {
                genCurPaymentTO();
            } else {
                clearTimeout(curPaymentTimeout);
            }
        });

        const isFetchingBankAccs = ref(false);
        const fetchBackAccs = async () => {
            isFetchingBankAccs.value = true;

            return ApiRequest.get('/payments/coin-wallets')
                .then(async resAccs => {
                    bankAccs.value = resAccs.data.data;
                })
                .finally(() => {
                    isFetchingBankAccs.value = false;
                });
        }

        const fetchPaymentInfo = async () => {
            isLoading.value = true;

            return ApiRequest.get('/payments/ebank-prefix')
                .then(async resPrefix => {
                    transPrefix.value = resPrefix.data.data;

                    if (!transPrefix.value) {
                        return;
                    }

                    fetchBackAccs();

                    return ApiRequest.get('/payments/ebanks/latest')
                        .then(async res => {
                            const resData = res.data.data;
                            transId.value = resData.id;
                        });
                })
                .finally(() => {
                    isLoading.value = false;
                });
        };

        const isGenerating = ref(false);
        const genNewPayment = () => {
            isGenerating.value = true;
            ApiRequest.post('/payments/ebanks/latest')
                .then(async res => {
                    const resData = res.data.data;
                    transId.value = resData.id;

                    fetchBackAccs()
                        .then(() => {
                            if (bankAccsActiveKeys.value.indexOf('list') === -1) {
                                bankAccsActiveKeys.value.push('list');
                            }
                        });

                    message.success(t('message.success'));
                })
                .finally(() => {
                    isGenerating.value = false;
                });
        };

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const deletePaymentConfirm = (record: any) => {
            Modal.confirm({
                title: t('text.confirm'),
                content: `#${record.id}: ${record.user.name}`,
                maskClosable: true,
                autoFocusButton: 'cancel',
                onOk: async () => {
                    return ApiRequest.del(`/payments/ebanks/${record.id}`)
                        .then(() => {
                            message.success(t('message.success'));
                        })
                        .finally(() => {
                            fetchData();
                        });
                }
            });
        };

        const fetchDataInterval = setInterval(() => {
            if (hasManagerPermission.value && !isLoadingTable.value) {
                fetchData();
            }
        }, 60000);

        watch(() => userInfo.value, () => {
            if (hasManagerPermission.value) {
                fetchData();
            }
        });

        onMounted(() => {
            fetchPaymentInfo();

            if (hasManagerPermission.value) {
                fetchData();
            }
        });

        onUnmounted(() => {
            clearInterval(fetchDataInterval);
            clearTimeout(curPaymentTimeout);
        });

        return {
            isLoading,

            transPrefix,
            transId,
            bankAccs,
            bankAccsActiveKeys,
            fetchPaymentInfo,
            genNewPayment,
            isGenerating,
            fetchBackAccs,
            isFetchingBankAccs,
            bankAccsCols,

            number_format,

            dataSource,
            columns,
            pagination,
            isLoadingTable,
            deletePaymentConfirm,

            userInfo,
            hasManagerPermission,

            PaymentStatus,

            RouteName,

            UserRole,
        };
    },
})
</script>

<style scoped>

</style>
